import React, {useState} from 'react'
import PropTypes from 'prop-types'
import '../../css/components/tabs.css'
import Dropdown from "../dropdowns/dropdown-1";

export const VerticalTabs
    = ({tabs}) => {
    const [openTab, setOpenTab] = useState(0)
    return (
        <div className="flex flex-row items-start justify-start tabs">
            <div className="flex-shrink-0">
                <div className="flex flex-wrap flex-col space-y-2">
                    {tabs.map((tab, key) => (
                        <button
                            key={key}
                            onClick={() => {
                                setOpenTab(tab.index)
                            }}
                            className={`tab tab-pill ${
                                openTab === tab.index ? 'tab-active' : ''
                            }`}
                            type="button">
                            {tab.title}
                        </button>
                    ))}
                </div>
            </div>
            <div className="ml-0">
                {tabs.map((tab, key) => (
                    <div
                        className={`tab-content ${
                            openTab !== tab.index ? 'hidden' : 'block'
                        }`}>
                        {openTab === tab.index ? tab.content : <></>}
                    </div>
                ))}
            </div>
        </div>
    )
}

VerticalTabs.propTypes = {
    tabs: PropTypes.arrayOf(
        PropTypes.shape({
            index: PropTypes.number,
            content: PropTypes.element,
            title: PropTypes.any
        })
    ).isRequired
}

export const Pills = ({tabs}) => {
    const [openTab, setOpenTab] = useState(0)
    return (
        <div className="flex flex-wrap flex-col w-full tabs">
            <div className="flex lg:flex-wrap flex-row lg:space-x-2">
                {tabs.map((tab, key) => (
                    <div key={key} className="flex-none">
                        <button
                            onClick={() => {
                                setOpenTab(tab.index)
                            }}
                            className={`tab tab-pill ${
                                openTab === tab.index ? 'tab-active' : ''
                            }`}
                            type="button">
                            {tab.title}
                        </button>
                    </div>
                ))}
            </div>
            {tabs.map((tab, key) => (
                <div
                    className={`tab-content ${
                        openTab !== tab.index ? 'hidden' : 'block'
                    }`}>
                    {tab.content}
                </div>
            ))}
        </div>
    )
}

Pills.propTypes = {
    tabs: PropTypes.arrayOf(
        PropTypes.shape({
            index: PropTypes.number,
            content: PropTypes.element,
            title: PropTypes.any
        })
    ).isRequired
}

export const IconTabs = ({tabs, setOpenedTab, disableNonActiveTab = false, initOpenTab = 0}) => {
    let [openTab, setOpenTab] = useState(initOpenTab)
    const getTabTitle = (index) => {
        if (tabs[index]?.title) {
            return tabs[index].title;
        } else {
            return `#${index + 1}`;
        }
    }
    return (
        <div className="flex flex-wrap flex-col w-full tabs ">
            <div className="flex flex-row lg:hidden visible">
                <div className={"min-w-xxs"}>
                    <Dropdown
                        disabled={false}
                        width="w-64"
                        placement={`bottom-start`}
                        title={getTabTitle(openTab)}
                        dropdownToggleClass={`w-full btn btn-default border btn-rounded bg-white text-enigoo-500 border-enigoo-500 btn-icon hover:bg-enigoo-600 bg-enigoo-500 hover:text-white space-x-1 mt-1 mr`}>
                        <>
                            <div className="flex flex-col text-center">
                                {tabs.map((tab, index) => (
                                    <div
                                        key={index}
                                        className="items-center flex flex-wrap justify-center h-8 space-y-1 dropdown-item">
                                        <button onClick={() => {
                                            setOpenTab(tab.index);
                                            setOpenedTab && setOpenedTab(tab.index);

                                        }}
                                                className="btn btn-icon text-xs w-full btn-rounded h-full hover:bg-enigoo-500 hover:text-white">{tab.title}</button>
                                    </div>
                                ))}
                            </div>
                        </>
                    </Dropdown>
                </div>
            </div>

            <div className="lg:flex lg:flex-wrap hidden">

                {tabs.map((tab, index) => (
                    <div key={index.toString()} className="flex-none m-1">
                        <button
                            onClick={() => {
                                setOpenTab(tab.index);
                                setOpenedTab && setOpenedTab(tab.index);
                            }}
                            className={`tab rounded-lg shadow flex flex-row items-center justify-around ${
                                openTab === tab.index ? 'tab-active' : ''
                            }`}
                            type="button">
                            {tab.title}
                        </button>
                    </div>
                ))}

            </div>
            {tabs.map((tab, key) => (
                <div key={key.toString()}
                     className={`tab-content ${
                         openTab !== tab.index ? 'hidden' : 'block'
                     }`}>
                    {openTab !== tab.index && disableNonActiveTab ? <></> : tab.content}
                </div>
            ))}
        </div>
    )
}

IconTabs.propTypes = {
    tabs: PropTypes.arrayOf(
        PropTypes.shape({
            index: PropTypes.number,
            content: PropTypes.element,
            title: PropTypes.any
        })
    ).isRequired
}


export const UnderlinedTabs = ({tabs}) => {
    const [openTab, setOpenTab] = useState(0)
    return (
        <div className="flex flex-wrap flex-col w-full tabs">
            <div className="flex lg:flex-wrap flex-row lg:space-x-2">
                {tabs.map((tab, key) => (
                    <div key={key} className="flex-none">
                        <button
                            onClick={() => {
                                setOpenTab(tab.index)
                            }}
                            className={
                                openTab === tab.index
                                    ? 'tab tab-underline tab-active'
                                    : 'tab tab-underline'
                            }
                            type="button">
                            {tab.title}
                        </button>
                    </div>
                ))}
            </div>
            {tabs.map((tab, key) => (
                <div
                    key={key}
                    className={`tab-content ${
                        openTab !== tab.index ? 'hidden' : 'block'
                    }`}>
                    {tab.content}
                </div>
            ))}
        </div>
    )
}

UnderlinedTabs.propTypes = {
    tabs: PropTypes.arrayOf(
        PropTypes.shape({
            index: PropTypes.number,
            content: PropTypes.element,
            title: PropTypes.any
        })
    ).isRequired
}

export const DefaultTabs = ({tabs}) => {
    const [openTab, setOpenTab] = useState(0)
    return (
        <div className="flex flex-wrap flex-col w-full tabs">
            <div className="flex lg:flex-wrap flex-row lg:space-x-2">
                {tabs.map((tab, key) => (
                    <div key={key} className="flex-none">
                        <button
                            onClick={() => {
                                setOpenTab(tab.index)
                            }}
                            className={`tab ${openTab === tab.index ? 'tab-active' : ''}`}
                            type="button">
                            {tab.title}
                        </button>
                    </div>
                ))}
            </div>
            {tabs.map((tab, key) => (
                <div
                    className={`tab-content ${
                        openTab !== tab.index ? 'hidden' : 'block'
                    }`}>
                    {tab.content}
                </div>
            ))}
        </div>
    )
}

DefaultTabs.propTypes = {
    tabs: PropTypes.arrayOf(
        PropTypes.shape({
            index: PropTypes.number,
            content: PropTypes.element,
            title: PropTypes.any
        })
    ).isRequired
}
